import { ListItemSecondaryAction } from "@mui/material";
import React, { useEffect, useState, useContext } from "react";
import MainCard from "ui-component/cards/MainCard";
import {
  Autocomplete,
  Card,
  Grid,
  TextField,
} from "@mui/material";


import SubCard from "ui-component/cards/SubCard";
import { gridSpacing } from "store/constant";
import { Box } from "@mui/material";
import endpoints from "utils/services/EndPoints";
import Api from "utils/services/Api";
import { message, Steps } from "antd";
import Button from "@mui/material/Button";


import { initPersonCompletaMS } from "utils/types";
import FeatherIcon from "feather-icons-react";
// import esLocale from "date-fns/locale/es";
import { validaIdentificacionPersona, validaCorreo } from "utils/utils";
import Steeper from "components/Steps/Steeper";
import { stepsPersonas } from "utils/Constantes";
import { procesoOK, procesoWarning, procesoError } from "utils/Constantes";
import { getCodigoUsuario, getCodigoIfip } from "utils/Common";
import { iniInfoConyuge } from "utils/types";
import { InitTipoIdentificacionMS } from "utils/types";
import { InitTipoPersonaMS } from "utils/types";

export const NuevoConyugeForm = (props) => {
  console.log('props');
  console.log(props);
  const generarNotificacion = (abrir, mensaje, color) => {
    setOpenNotificacion(abrir);
    setVisualizaMensaje(mensaje);
    if (color === 1) {
      setColorNotificacion(procesoOK);
    }
    if (color === 2) {
      setColorNotificacion(procesoWarning);
    }
    if (color === 3) {
      setColorNotificacion(procesoError);
    }
  };
  const [listIdType, setListIdType] = useState([]);
  const [listPersonType, setistPersonType] = useState([]);
  const [openTipoIdentificacion, setOpenTipoIdentificacion] =
    React.useState(false);
  const [openNotificacion, setOpenNotificacion] = useState(false);
  const [visualizaMensaje, setVisualizaMensaje] = useState("");
  const [colorNotificacion, setColorNotificacion] = useState("");

  const [openTipoPersona, setOpenTipoPersona] = React.useState(false);
  const [objTipoIdentificacion, setObjTipoIdentificacion] = useState({});
  const [objTipoPersona, setObjTipoPersona] = useState({});
  const [objPerson, setObjPerson] = useState(iniInfoConyuge());
  const [edicion, setEdicion] = useState(false);
  const [ejecutaBusqueda, setEjecutaBusqueda] = useState(false)
  const { setPerson, datoConyuge,notificaError } = props;

 


  useEffect(() => {
    (async () => {
  if(datoConyuge===0)
  return
      console.log(endpoints.getInformacionConyuge + "/" + datoConyuge + "/")
      Api(
        endpoints.getInformacionConyuge + "/" + datoConyuge + "/",
        "GET",
        null
      )
        .then((response) => {
          if (response.codigoPersona > 0)
            setEdicion(true)
          setObjPerson(response)
          setPerson(response.codigoPersona)
        })
        .catch((error) => {
          console.log(error);
        });
    })();
  }, [props]);

  useEffect(() => {
    (async () => {
if(edicion)
setEjecutaBusqueda(true)
    })();
  }, [edicion]);
  useEffect(() => {
    (async () => {
      console.log("ingresaopenTipoPersona");
      Api(endpoints.listPersonTypes, "GET", null)
        .then((response) => {
          setistPersonType(response);
        })
        .catch((error) => {
          console.log(error);
        });
    })();
  }, [openTipoPersona]);


  useEffect(() => {
    (async () => {
      console.log("ingresa openTipoIdentificacion");
      Api(endpoints.listIdentificacionType, "GET", null)
        .then((response) => {
          console.log(response);
          setListIdType(response);
        })
        .catch((error) => {
          console.log(error);
        });
    })();
  }, [openTipoIdentificacion]);

  useEffect(() => {
    if (!ejecutaBusqueda)
      return
    console.log('props5555');
    (async () => {
      Api(
        endpoints.obtieneConyugeIdentificacion + "/" + objPerson.numeroIdentificacion,
        "GET",
        null
      )
        .then((response) => {
          if (response.estado === -1) {
            setObjPerson(iniInfoConyuge())
            generarNotificacion(true, response.mensaje, 2);
            return
          }

          if (response.codigo === 0) {
            generarNotificacion(
              true,
              "No existe el socio de acuerdo al numero de identificacion ingresado",
              2
            );
            return;
          } else {
            generarNotificacion(true, "Consulta datos exitoso", 1);
            setObjPerson(response)
            setPerson(response.codigoPersona)

          }
        })
        .catch((error) => {
          generarNotificacion(true, error.message, 3);
        });
    })();
  }, [ejecutaBusqueda]);

  const cerrarNotificacion = () => {
    setOpenNotificacion(false);
  };
 /* const getByIdentificacion = () => {
    try {
      (async () => {
        Api(
          endpoints.obtieneConyugeIdentificacion + "/" + objPerson.numeroIdentificacion,
          "GET",
          null
        )
          .then((response) => {
            if (response.estado === -1) {
              setObjPerson(iniInfoConyuge())
              generarNotificacion(true, response.mensaje, 2);
              return
            }

            if (response.codigo === 0) {
              generarNotificacion(
                true,
                "No existe el socio de acuerdo al numero de identificacion ingresado",
                2
              );
              return;
            } else {
              generarNotificacion(true, "Consulta datos exitoso", 1);
              setObjPerson(response)


            }
          })
          .catch((error) => {
            generarNotificacion(true, error.message, 3);
          });
      })();
    } catch (error) {
      generarNotificacion(true, error.message, 3);
    }
  }*/
  const savePerson = () => {
    if (
      objPerson.numeroIdentificacion === "" ||
      objPerson.numeroIdentificacion === undefined
    ) {
      console.log(
        "Ingrese un número de identificación válido para continuar. "
      );
      return;
    }
    if (objPerson.nombres === "" || objPerson.nombres === undefined) {
      console.log("Ingrese un nombre válido para continuar. ");
      return;
    }
    if (
      objPerson.primerApellido === "" ||
      objPerson.primerApellido === undefined
    ) {
      console.log("Ingrese un apellido válido para continuar. ");
      return;
    }
    if (
      objPerson.segundoApellido === "" ||
      objPerson.segundoApellido === undefined
    ) {
      console.log("Ingrese un apellido válido para continuar. ");
      return;
    }
    if (
      objPerson.correoElectronico === "" ||
      objPerson.correoElectronico === undefined
    ) {
      console.log("Ingrese un correo electrónico válido para continuar. ");
      return;
    }
 /*    if (
      objTipoPersona.value.codigo === 0 ||
      objTipoPersona.value.codigo === undefined
    ) {
      console.log("Ingrese un tipo de persona válido para continuar. ");
      return;
    } */
/* 
    if (
      objTipoIdentificacion.value.codigo === 0 ||
      objTipoIdentificacion.value.codigo === undefined
    ) {
      console.log("Ingrese un tipo de identificación válido para continuar. ");
      return;
    } */
    const codigo = 1;
    // Arma objeto
    const objPersonaRegistro = {
      codigoPersona: objPerson.codigoPersona ? objPerson.codigoPersona : 0,
      numeroIdentificacion: objPerson.numeroIdentificacion,
      nombres: objPerson.nombres,
      primerApellido: objPerson.primerApellido,
      segundoApellido: objPerson.segundoApellido,
      correoElectronico: objPerson.correoElectronico,
      tipoPersona: {
        codigo: 1,
        descripcion: 'objTipoPersona.value.title',
      },
      tipoIdentificacion: {
        codigo: 1,
        descripcion: 'cedula',
      },
      codigoEntidad: getCodigoIfip(),
      fechaNacimiento: Date.now(),
      codigoUsuarioActualiza: getCodigoUsuario(),
      codigoUsuarioRegistra: getCodigoUsuario(),
      fechaActualiza: Date.now(),
      fechaRegistro: Date.now(),
      fechaCaducidadIdentificacion: Date.now(),
    };
    console.log(objPersonaRegistro);

    if (codigo === 1) {
      (async () => {
        Api(endpoints.savePersonBasic, "POST", objPersonaRegistro)
          .then((response) => {
            generarNotificacion(true, "Guardado Correctamente", 1);
            setEjecutaBusqueda(true)
          })
          .catch((error) => {
            //generarNotificacion(true, error.message, 3);
          });
      })();
    }
  };

  return (<>
    <MainCard
      title="Información Conyuge"
      open={openNotificacion}
      mensajeVizualizar={visualizaMensaje}
      colorProceso={colorNotificacion}
      style={{ heigth: "100vh" }}
      handleClose={() => cerrarNotificacion()}
      secondary={
        <ListItemSecondaryAction link="https://next.material-ui.com/system/typography/" />
      }
    >
      <>
        <div>
          <Grid container  >
            <TextField

              label="Identificación"
              margin="normal"
              name="fname"
              type="text"
              value={objPerson.numeroIdentificacion ? objPerson.numeroIdentificacion : ''}
              onChange={(e) => {
                const valor = e.target.value;
                if (isNaN(valor)) {
                  return false;
                }
                if (valor.length >= 13) {
                  return false;
                }
                setObjPerson((prevState) => {
                  return { ...prevState, numeroIdentificacion: valor };
                });
              }}
            />
            <Button
              type="primary"
              block
              htmlType="submit"
              loading={true}
              onClick={() =>setEjecutaBusqueda(true)}
            >
              <FeatherIcon icon="search" size={16} />
            </Button>
          </Grid>

        </div>
        <div>
          {false &&( <Grid container >
           
            <Grid item xs={12} md={6}>
              <Autocomplete
                id="id"
                options={listIdType}
                getOptionLabel={(option) => option.descripcion || ""}
                style={{ width: '90%' }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Tipo Identificacion"
                    variant="outlined"
                  />
                )}
                onOpen={() => {
                  setOpenTipoIdentificacion(true);
                }}
                onClose={() => {
                  setOpenTipoIdentificacion(false);
                }}
                value={objTipoIdentificacion.codigo}
                onChange={(event, value) => {
                  setObjTipoIdentificacion((prevState) => {
                    return { ...prevState, value };
                  });
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Autocomplete
                id="personType"
                options={listPersonType}
                getOptionLabel={(option) => option.descripcion || ""}
                style={{ width: '90%' }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Tipo Persona"
                    variant="outlined"
                  />
                )}
                onOpen={() => {
                  setOpenTipoPersona(true);
                }}
                onClose={() => {
                  setOpenTipoPersona(false);
                }}
                value={objTipoPersona.codigo}
                onChange={(event, value) => {
                  setObjTipoPersona((prevState) => {
                    return { ...prevState, value };
                  });
                }}
              />
            </Grid>
          </Grid>
          )}
        </div>
        <div enabled>
          <Grid container >
            <Grid item xs={12} md={6}>
              <TextField
                style={{ width: '90%' }}
                fullWidth
                label="Nombre"
                margin="normal"
                name="fname"
                type="text"
                value={objPerson.nombres}
                onChange={(e) => {
                  const valor = e.target.value;
                  if (!validaIdentificacionPersona.test(valor)) {
                    return false;
                  }
                  setObjPerson((prevState) => {
                    return { ...prevState, nombres: valor };
                  });
                }}
              />

            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                style={{ width: '90%' }}
                label="Primer Apellido"
                margin="normal"
                name="fname"
                type="text"
                value={objPerson.primerApellido}
                onChange={(e) => {
                  const valor = e.target.value;
                  if (!validaIdentificacionPersona.test(valor)) {
                    return false;
                  }
                  setObjPerson((prevState) => {
                    return { ...prevState, primerApellido: valor };
                  });//pruebas
                }}
              />
            </Grid>

          </Grid>
        </div>
      <div>
          <Grid container>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                style={{ width: '90%' }}
                label="Segundo Apellido"
                margin="normal"
                name="fname"
                type="text"
                value={objPerson.segundoApellido}
                onChange={(e) => {
                  const valor = e.target.value;
                  if (!validaIdentificacionPersona.test(valor)) {
                    return false;
                  }
                  setObjPerson((prevState) => {
                    return { ...prevState, segundoApellido: valor };
                  });
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                style={{ width: '90%' }}
                label="Correo Electronico"
                margin="normal"
                name="fname"
                type="text"
                value={objPerson.correoElectronico}
                onChange={(e) => {
                  const valor = e.target.value;
                  /* if (validaCorreo.test(valor)) {
                      return false;
                    } */
                  if (valor.length > 50) {
                    return false;
                  }
                  setObjPerson((prevState) => {
                    return { ...prevState, correoElectronico: valor };
                  });
                }}
              />
            </Grid>
          </Grid>
        </div>
        <div className="steps-action">

          <Button
            type="primary"
            block
            htmlType="submit"
            loading={true}
            onClick={() => savePerson()}
          >
            <FeatherIcon icon="save" size={16} /> &nbsp; {ejecutaBusqueda ? 'Actualiza datos' : 'Crea Conyuge'}
          </Button>

        </div>
      </>
    </MainCard>
  </>)
};
